// extracted by mini-css-extract-plugin
export default {"list":"list_list__Lf-pG","services":"list_services__UwFcw","item":"list_item__IkcYz","itemContent":"list_itemContent__a2xpj","link":"list_link__yF9Zy","bgIcon":"list_bgIcon__CYej-"};